export default __webpack_public_path__ + "assets/images/a3803c425999eaaab1e8475d5e680536.svg";